<template>
  <div class="container user-index-container">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="card-header-label col-2">
            <span class="mdi mdi-account-supervisor custom-icon"></span>
            <span>Usuarios</span>
          </div>
          <div class="card-header-search-bar col-5">
            <b-form-input
              v-model="filter" 
              id="filter-input"
              placeholder="Escriba aquí el texto a buscar"/>
          </div>
          <div class="card-header-pagination col-3">
            <b-pagination
              v-model="currentPage"
              :total-rows="filteredList ? filteredList.length : 0"
              :per-page="perPage"
              aria-controls="list-table"
              style="margin: 0;"
              align="center"
              
            />
          </div>
          <div class="card-header-action-buttons col-2">
            <div>
                <ButtonComponent
                  :buttonText="'Nuevo'"
                  :buttonColor="colors.GREEN_COLOR_BUTTON"
                  :buttonAction="openCreateModal"
                />
                <ButtonComponent
                  :buttonText="'Refrescar'"
                  :buttonColor="colors.BLUE_COLOR_BUTTON"
                  :buttonAction="refreshData"
                />
              </div>
          </div>
        </div>
      </div>
      <div v-if="isLoading" style="padding: 5ch 0;">
        <SpeenComponent  
          :isAutomatic="true"
          :ringWidth="14"
          :spinnerSize="15"
          :isverticalAligned="true"
        />
      </div>
      <div class="card-body" v-else>
        <b-table 
          :items="filteredList" 
          :fields="fields" 
          small 
          striped 
          hover 
          :per-page="perPage" 
          :current-page="currentPage"
          id="list-table"
        >
          <template #cell(operator.name)="data">
            <span v-if="data.item.operator">{{ data.item.operator.name }}</span>
            <span v-else>Sin operador</span>
          </template>
          <template v-if="canCloseSessions" #cell(session_token)="data">
            <ButtonComponent
              v-if="data.item.session_token"
              :disabled="!showButtonForUser(data.item)"
              :buttonText="'Cerrar sesión'"
              :buttonColor="colors.RED_COLOR_BUTTON"
              :buttonAction="() => confirmSessionClose(data.item)"
            />
            <ButtonComponent
              v-else
              :disabled="true"
              :buttonText="'No iniciada'"
              :extraStyles="{ width: '12.7ch' }"
              :buttonColor="colors.GRAY_COLOR_BUTTON"
            />
          </template>
          <template #cell(actions)="data">
            <ButtonComponent
              :buttonText="'Editar'"
              :buttonColor="colors.GREEN_COLOR_BUTTON"
              :buttonAction="() => openEditModal(data.item)"
            />
            <ButtonComponent
              :disabled="!showButtonForUser(data.item)"
              :buttonText="'Borrar'"
              :buttonColor="colors.RED_COLOR_BUTTON"
              :buttonAction="() => confirmDeleteUser(data.item)"
            />
            <ButtonComponent
              :buttonText="'Roles'"
              :buttonColor="colors.BLUE_COLOR_BUTTON"
              :buttonAction="() => openRolesModal(data.item)"
            />
          </template>
        </b-table>
      </div>
    </div>
    <transition name="slide-fade">
      <CreateUserModal
        v-if="showCreateModal"
        @user-created="refreshData"
        @close-modal="closeCreateModal"
      />
      <EditUserModal
        v-if="showEditModal"
        :formEdit="formEdit"
        @form-submitted="refreshData"
        @close-modal="closeEditModal"
      />
      <EditUserRolesModal
        v-if="showRolesModal"
        :selectedUserId="selectedUserId"
        :selectedUserName="selectedUserName"
        @close-modal="closeRolesModal"
      />
      <ActionConfirmModal
        v-if="showActionConfirmModal"
        :contentMessage="actionConfirModalMessage"
        :closeModal="closeActionConfirmModal"
        :methodForProp="methodForProp"
      />
    </transition>
  </div>
</template>
  
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import SpeenComponent from '../../common/components/SpeenComponent.vue';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';
import PermissionsConsts from '../../common/permissions';
import ButtonComponent from '../../common/components/ButtonComponent.vue';
import Colors from '../../common/colors.js'
import { filterList } from '../../common/utils.js';
import ActionConfirmModal from "../../common/components/modals/ActionConfirmModal.vue";
import CreateUserModal from '../components/CreateUserModal.vue';
import EditUserModal from '../components/EditUserModal.vue';
import EditUserRolesModal from '../components/EditUserRolesModal.vue';

export default {
  name: 'UserIndexComponent',
  components: {
    SpeenComponent,
    ButtonComponent,
    ActionConfirmModal,
    CreateUserModal,
    EditUserModal,
    EditUserRolesModal,
  },
  data() {
    return {
      colors: Colors,
      success: null,
      error: null,
      perPage: 10,
      currentPage: 1,
      filter: '',
      listData: [],
      userId: -1,
      showCreateModal: false,
      formEdit: {
        id: -1,
        name: '',
        email: '',
        current_password: '',
        new_password: '',
        confirm_password: ''
      },
      showEditModal: false,
      isLoading: true,
      showRolesModal: false,
      selectedRoles: [], 
      allRoles: [],
      selectedUserId: null,
      selectedUserName:"",
      showActionConfirmModal: false,
      actionConfirModalMessage: '',
      methodForProp: null,
    };
  },
  computed: {
    ...mapGetters(['userPermissions', 'userHasPermission', 'isUserAdmin', 'isUserSuperadmin', 'username']),
    filteredList() {
      return filterList(this.listData, this.fields, this.filter);
    },
    fields() {
      let baseFields = [
        { key: 'name',          label: 'Nombre',        thStyle: { width: '18%' }, tdStyle: { width: '18%' }, sortable: true },
        { key: 'username',      label: 'Usuario',       thStyle: { width: '15%' }, tdStyle: { width: '15%' }, sortable: true },
        { key: 'email',         label: 'Correo',        thStyle: { width: '25%' }, tdStyle: { width: '25%' }, sortable: true },
        { key: 'operator.name', label: 'Operador',      thStyle: { width: '15%' }, tdStyle: { width: '15%' }, sortable: true },
        { key: 'session_token', label: 'Sesión',        thStyle: { width: '10%' }, tdStyle: { width: '10%' }, sortable: true },
        { key: 'actions', label: 'Acciones', thStyle: { width: '17%' }, tdStyle: { width: '17%' } },
      ];
      return baseFields;
    },
    canCloseSessions() {
      return this.isUserSuperadmin || this.isUserAdmin;
    }
  },
  methods: 
  {
    getList() {
      this.isLoading = true;
      axios.get('/api/user')
        .then(response => {
          this.listData = response.data;
          this.isLoading = false;
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
          console.error(error);
        });
    },
    refreshData()
    {
      this.getList();
    },
    confirmDeleteUser(user) 
    {
      this.actionConfirModalMessage = `¿Está seguro de que desea eliminar el usuario ${user.name}?`;
      this.methodForProp = () => { 
        this.deleteUser(user); 
      };
      this.openActionConfirmModal();
    },
    deleteUser(user) 
    {
      axios.delete(`/api/user/admon/${user.id}`)
        .then(() => {
          showCustomSuccessSweetAlert('Usuario eliminado correctamente');
          this.getList();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        })
        .finally(() => {
          this.closeActionConfirmModal();
          this.getList();
        });
    },
    openCreateModal()
    {
      this.showCreateModal = true;
    },
    closeCreateModal() 
    {
      this.showCreateModal = false;
    },
    openEditModal(user) 
    {
      this.formEdit = {
        id: user.id,
        name: user.name,
        email: user.email,
        current_password: '',
        new_password: '',
        confirm_password: ''
      };
      this.showEditModal = true;
    },
    closeEditModal() 
    {
      this.showEditModal = false;
    },
    openRolesModal(user) 
    {
      this.selectedUserId = user.id;
      this.selectedUserName = user.name;
      this.showRolesModal = true;
    },
    closeRolesModal() 
    {
      this.showRolesModal = false;
    },
    sessionClass(sessionToken) 
    {
      return sessionToken ? 'session-active' : 'session-inactive';
    },
    confirmSessionClose(user) {
      this.actionConfirModalMessage = `¿Está seguro de que desea cerrar la sesión de ${user.name}?`;
      this.methodForProp = () => { 
        this.closeSession(user.id);
      };
      this.openActionConfirmModal();
    },
    closeSession(userId) {
      axios.put(`/api/user/session-token-individual-nuller/${userId}`)
        .then(response => {
          showCustomSuccessSweetAlert('Sesión cerrada correctamente');
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        })
        .finally(() => {
          this.closeActionConfirmModal();
          this.getList();
        });
    },
    showButtonForUser(user){
      return user.username !== this.username;
    },
    openActionConfirmModal() {
      this.showActionConfirmModal = true;
    },
    closeActionConfirmModal() {
      this.showActionConfirmModal = false;
    },
  },
  mounted() 
  {
    this.getList();
  },
};
</script>
  
<style lang="scss">
.user-index-container{
  #list-table {
    [aria-colindex="1"] {width: 18%;}
    [aria-colindex="2"] {width: 15%;}
    [aria-colindex="3"] {width: 25%;}
    [aria-colindex="4"] {width: 15%;}
    [aria-colindex="5"] {width: 10%;}
    [aria-colindex="6"] {width: 15%;}
  }
}
</style>
